module.exports = __webpack_public_path__ + "img/4-1-3-3-preview-staycationoffers-e.99e0a350.jpg";